<template>

    <div
        v-for="(valyear, indexyear) in calendardata.calendar"
        :key="indexyear" 
        :id="calendartype === undefined ? `calendar-container-${indexyear}` : `calendar-container-${calendartype}-${indexyear}`"
        :class="parseInt(indexyear) !== date.year ? `calendar-container-${indexyear} d-none` : `calendar-container-${indexyear} d-flex`" 
        class="flex-column search-select-day-base"
    >

        <div
            v-for="(valmonth, indexmonth) in valyear"
            :id="calendartype === undefined ? `calendar-month-base-${indexyear}-${indexmonth}` : `calendar-month-base-${calendartype}-${indexyear}-${indexmonth}`"
            :class="calendartype === undefined ? 
            `calendar-month-base-${indexyear} calendar-month-base-${indexyear}-${indexmonth} ${currentMonthConditional(parseInt(indexyear), parseInt(indexmonth))}` : 
            `calendar-month-base-${calendartype}-${indexyear} calendar-month-base-${calendartype}-${indexyear}-${indexmonth} ${currentMonthConditional(parseInt(indexyear), parseInt(indexmonth))}`" 
            class="calendar-month-base"
            :data-monthrefer="indexmonth"
            :data-yearrefer="indexyear"
        >

            <div :class="`${classnamebase} search-select-day-base`">

                <div
                    :id="`calendar-header-${indexyear}-${indexmonth}`" 
                    class="calendar-header d-flex flex-row justify-content-between"
                    :data-monthrefer="indexmonth"
                    :data-yearrefer="indexyear"
                    @click="calendarNavigation(
                        $event,
                        date.year,
                        (date.year + 1),
                        date.month,
                        indexyear,
                        indexmonth
                    )"
                >
                    <span
                        id="calendar-btn-prev-" 
                        class="calendar-btn calendar-btn-prev"
                        :data-monthrefer="(parseInt(indexmonth) - 1)"
                        :data-yearrefer="prevOrNextYearReference('prev', parseInt(indexmonth), parseInt(indexyear))"
                        data-action="prev"
                        role="button"
                    >
                        &lt;
                    </span>
                    <div 
                        class="d-flex flex-column justify-content-center align-items-center calendar-month-year-base"
                    >
                        <span id='calendar-header-next-' class='calendar-current-year'>{{ indexyear }}</span>
                        <h5 class='text-center' aria-describedby='Current Month Name'>{{ allmonths[indexmonth] }}</h5>
                    </div>
                    <span
                        id="calendar-btn-next" 
                        class="calendar-btn calendar-btn-next"
                        :data-monthrefer="(parseInt(indexmonth) + 1)"
                        :data-yearrefer="prevOrNextYearReference('next', parseInt(indexmonth), parseInt(indexyear))"
                        data-action="next"
                        role="button"
                    >
                        &gt;
                    </span>
                </div>

                <div class="d-flex flex-row search-select-day">
                    <!-- Calendar Table -->
                    <table-element
                        :classname="setTableClassName(indexyear, indexmonth)"
                    >
                        <!-- THead -->
                        <template #thead>
                            <tr>
                                <th scope="col">Se</th>
                                <th scope="col">Te</th>
                                <th scope="col">Qu</th>
                                <th scope="col">Qu</th>
                                <th scope="col">Se</th>
                                <th scope="col">Sa</th>
                                <th scope="col">Do</th>
                            </tr>
                        </template>

                        <!-- Tbody -->
                        <template #tbody>
                            <tr
                                v-for="(
                                    valweek, indexweek
                                ) in valmonth"
                                :key="indexweek"
                                class="weekrow"
                                :data-month="indexmonth"
                                :data-week="indexweek"
                                :data-year="indexyear"
                            >

                                <template v-if="typeof valweek === 'object'">
                                    <td
                                        v-for="(
                                            valday, indexday
                                        ) in valweek"
                                        :key="indexday"
                                        :class=" setDisabledDay(parseInt(valday.day), parseInt(indexmonth), parseInt(indexyear), 'disabledday', valday.weekday)"
                                        :data-referindex="indexday"
                                        :data-weekdaynumber="
                                            valday.weekdaynumber
                                        "
                                        :data-week="indexweek"
                                        :data-weekday="valday.weekday"
                                        :data-month="indexmonth"
                                        :data-year="indexyear"
                                        @click="
                                            getSelectDate(
                                                $event,                   
                                            )
                                        "
                                    >
                                        <span>{{ valday.day }}</span>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="disabledclick"></td>
                                </template>
                            </tr>
                        </template>
                    </table-element>
                </div>
            </div>

        </div>

    </div>

</template>
<script>
import Table from './TableElement.vue';
import calendarRoutine from './../../calendarScript.js';

//Set Use Strict
("use strict");

export default{
    name: 'CalendarElement',
    emits: ['select_date', 'clean_data'],
    props: {
        classnamebase:{
            type: String,
            required: true
        },
        tableclassname:{
            type: Array,
            required: false
        },
        calendardata:{
            type: Object,
            required: true
        },
        tdclassname: {
            type: String,
            required: true
        },
        allmonths:{
            type: Object,
            required: true
        },
        calendartype:{
            type: String,
            required: false
        }
    },
    data: () => {

        return {

            date: {}

        }

    },
    created(){

        //Set Date
        const DATE = new Date();
        this.date.year = parseInt(DATE.getFullYear());
        this.date.month = parseInt((DATE.getMonth() + 1));
        this.date.currentday = parseInt(DATE.getDate());

    },
    methods:{

        getSelectDate(element){

            return this.$emit('select_date', element);

        },
        currentMonthConditional(indexYear, monthIndex){

            let currentMonthConditional = '';

            //Set Month Conditional
            switch(indexYear){

                case this.date.year:
                    currentMonthConditional = monthIndex !== this.date.month ? 'd-none' : '';
                break;
                
                case (this.date.year + 1):
                    currentMonthConditional = monthIndex !== 1 ? 'd-none' : '';
                break;
                
                default:
                    currentMonthConditional = 'd-none';
                break;

            }

            return currentMonthConditional;

        },
        prevOrNextYearReference(indicate, monthIndex, indexYear){

            let reference = '';

            switch(indicate){

                case 'prev':

                    reference = monthIndex !== 1 ? indexYear : (indexYear - 1);

                break;

                case 'next':

                    reference = monthIndex !== 12 ? indexYear : (indexYear + 1);

                break;

            }

            return reference;

        },
        setTableClassName(indexyear, indexmonth){

            let tableclass = ['calendar-table'].concat([`calendar-table-${indexyear}-${indexmonth}`], this.tableclassname);

            return tableclass;

        },
        setDisabledDay(day, monthIndex, indexYear, classname, weekday){

            return weekday === 'Sunday' || day < this.date.currentday && monthIndex === this.date.month && indexYear === this.date.year ? `${this.tdclassname} ${classname} disabledclick` : `${this.tdclassname}`;

        },
        setDisabledClick(){

            return this.setDisabledDay(day, monthIndex, indexYear, classname);

        },
        calendarNavigation(
            element, 
            currentYear, 
            nextYear, 
            currentMonth,
            elReferYear,
            elReferMonth
        ){

            //Clean Old Data
            this.$emit('clean_data', []);

            //Calendar Nav
            calendarRoutine.calendarNavigation(
                element.target, 
                currentYear, 
                nextYear, 
                currentMonth,
                elReferYear,
                elReferMonth,
                this.calendartype === undefined ? 'calendar-container' : `calendar-container-${this.calendartype}`,
                this.calendartype === undefined ? 'calendar-month-base' : `calendar-month-base-${this.calendartype}`,
            );

        }

    },
    components:{
        tableElement: Table,
    }

}

</script>